import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatBadge } from '@angular/material/badge';
import { MatFabButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

import { ZendeskSupportToggleDirective } from '@zendesk/directives/zendesk-support-toggle.directive';
import { ZENDESK_STORE } from '@zendesk/stores/zendesk.store';

@Component({
  selector: 'app-zendesk-floating-button',
  standalone: true,
  templateUrl: './zendesk-floating-button.component.html',
  styleUrls: ['./zendesk-floating-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgClass,
    MatBadge,
    MatFabButton,
    MatIcon,
    MatTooltip,
    ZendeskSupportToggleDirective
  ]
})
export class ZendeskFloatingButtonComponent {
  readonly #zendeskStore = inject(ZENDESK_STORE);

  readonly canShowSupport = this.#zendeskStore.canShowWidget;
  readonly isSupportOpen = this.#zendeskStore.isOpen;
  readonly supportUnreadCount = this.#zendeskStore.unreadCount;
}
